import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getProducts } from '../services/api'
import { PageShell } from '../components/page/PageShell'
import { ProductCard } from '../components/products/ProductCard'

function SearchPage() {
  const [searchTerm, setSearchTerm] = useState('')
  const [category, setCategory] = useState('')

  const { data, isLoading, error } = useQuery({
    queryKey: ['products', 'search', searchTerm, category],
    queryFn: () =>
      getProducts({
        search: searchTerm || undefined,
        category: category || undefined,
        published_only: true,
      }),
    enabled: true,
    retry: 2,
    retryDelay: 1000,
  })

  const products = data?.products || []

  return (
    <PageShell
      backTo="/"
      backLabel="Hjem"
      breadcrumbs={[
        { label: 'Hjem', to: '/' },
        { label: 'Søg' },
      ]}
      actions={[
        { label: 'Padel bats', to: '/bat', primary: true },
      ]}
      title="Søg efter produkter"
      intro="Søg på navn, brand eller model på tværs af kategorier."
    >
      <div className="page-filters">
        <input
          type="search"
          placeholder="Søg efter produkt, brand, model..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          aria-label="Søgetekst"
        />
        <label>
          <span className="filter-label">Kategori</span>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="category-select"
          >
            <option value="">Alle kategorier</option>
            <option value="padel_bat">Padel bats</option>
            <option value="padel_ball">Padel bolde</option>
            <option value="padel_shoe">Padel sko</option>
          </select>
        </label>
      </div>

      {isLoading ? (
        <div className="page-loading">Søger...</div>
      ) : error ? (
        <div className="page-error">
          <p>Fejl ved søgning: {error.message}</p>
          <p>Prøv igen eller opdatere siden.</p>
        </div>
      ) : products.length > 0 ? (
        <>
          <p className="page-result-count">
            {products.length} resultat{products.length !== 1 ? 'er' : ''}
          </p>
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} summaryMax={0} />
            ))}
          </div>
        </>
      ) : (
        <div className="page-empty">Ingen produkter fundet</div>
      )}
    </PageShell>
  )
}

export default SearchPage
